import { get as idbGet, set as idbSet, del as idbDel } from 'idb-keyval';

const urlCache = new Map(); // key -> { url, revoker }
const makeKey = (id, file) => `photo:${id}:${file}`;

/**
 * Fotoğrafı (blob) önce IndexedDB’den, yoksa API’den yükler.
 * Tek bir objectURL üretir ve merkezi olarak cache’ler.
 * Component’ler revoke ETMESİN; sadece invalidateProfilePhoto ve beforeunload temizler.
 */
export async function loadProfilePhoto({ id, fileName, token }) {
  const key = makeKey(id, fileName);

  // 1) URL hafızada var mı?
  const cached = urlCache.get(key);
  if (cached) return { url: cached.url, revoke: cached.revoker };

  // 2) Blob IndexedDB’de mi?
  let blob = await idbGet(key);
  if (!blob) {
    const res = await fetch(
      `https://idealonline.com.tr/service/idealonline/v1/users/displayPhoto/${id}/${encodeURIComponent(fileName)}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (!res.ok) throw new Error('Photo fetch failed');
    blob = await res.blob();
    await idbSet(key, blob);
  }

  // 3) Tek seferlik objectURL üret ve cache’le
  const url = URL.createObjectURL(blob);
  const revoker = () => { URL.revokeObjectURL(url); urlCache.delete(key); };
  urlCache.set(key, { url, revoker });

  return { url, revoke: revoker };
}

/**
 * Yeni foto yüklendiğinde eski blob+URL’yi geçersiz kılmak için.
 */
export async function invalidateProfilePhoto({ id, oldFileName }) {
  if (!oldFileName) return;
  const key = makeKey(id, oldFileName);

  const cached = urlCache.get(key);
  if (cached) cached.revoker(); // objectURL’yi temizle

  await idbDel(key); // IndexedDB blob’unu sil
}

// Sayfa kapanırken tüm objectURL’leri merkezi olarak temizle
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    for (const { revoker } of urlCache.values()) revoker();
    urlCache.clear();
  });
}
